export function SectionContainer({
  title,
  description,
  action,
  children,
}: {
  title?: React.ReactNode
  description?: string
  action?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <div className="flex w-full flex-col gap-y-4 rounded py-5">
      {title && (
        <div className="flex items-center justify-between border-b pb-1">
          <div>
            {typeof title === 'string' ? <h3 className="text-base">{title}</h3> : title}
            {description && <p className="text-xs text-muted-foreground">{description}</p>}
          </div>
          {action && action}
        </div>
      )}
      {children}
    </div>
  )
}
